import { render, staticRenderFns } from "./CarShow.vue?vue&type=template&id=5e7dae61&scoped=true&"
import script from "./CarShow.vue?vue&type=script&lang=ts&"
export * from "./CarShow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7dae61",
  null
  
)

export default component.exports